export default {
  methods: {
    sortBy(type, direction) {
      if (direction === 1) this.renderFilterData.sort((a, b) => (a[type] > b[type] ? -1 : 1));
      else {
        this.renderFilterData.sort((a, b) => {
          if (a[type] === null) {
            a[type] = '';
          } else if (b[type] === null) {
            b[type] = '';
          }
          const firstElement = a[type].toUpperCase(); // ignore upper and lowercase
          const secondElement = b[type].toUpperCase(); // ignore upper and lowercase

          if (firstElement < secondElement) {
            return -1;
          }
          if (firstElement > secondElement) {
            return 1;
          }
          return 0;
        });
      }
    },
  },

};
